import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DetailsPage from "./tabs/DetailsPage";
import Commision from "./tabs/Commision";
import AgentOrderPayment from "./tabs/AgentOrderPayment";

export default function AgentOrderDetails() {
  const [activeTab, setActiveTab] = useState("details");
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderId = params.get("id");
  const tabName = params.get("tab");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    navigate(`?id=${orderId}&tab=${tabName}`);
  };

  useEffect(() => {
    setActiveTab(tabName || "details"); 
  }, [tabName]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header card-header2" style={{ paddingBottom: "12px" }}>
                <div className="d-flex">
                  <Link
                    to={`?id=${orderId}&tab=details`}
                    className={`${
                      activeTab === "details" ? "active-tab" : ""
                    } card-title--medium card-title2`}
                    onClick={() => handleTabChange("details")}
                  >
                    Agent Order Details
                  </Link>

                  <Link
                    to={`?id=${orderId}&tab=commision`}
                    className={`${
                      activeTab === "commision" ? "active-tab" : ""
                    } card-title--medium card-title2 ms-5`}
                    onClick={() => handleTabChange("commision")}
                  >
                    Commission
                  </Link>

                  <Link
                    to={`?id=${orderId}&tab=payment`}
                    className={`${
                      activeTab === "payment" ? "active-tab" : ""
                    } card-title--medium card-title2 ms-5`}
                    onClick={() => handleTabChange("payment")}
                  >
                    Agent Order Payment
                  </Link>
                </div>
                <div className="d-flex">
                  <h5 className="order-id card-title--medium card-title2 back-head">
                    Order: #{orderId}
                  </h5>
                  <Link to="/agent/agent-order">
                    <img
                      src="/assets/images/kidskart/icon/back-button.png"
                      alt="Back"
                    />
                  </Link>
                </div>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === "details" && <DetailsPage />}
                {activeTab === "commision" && <Commision />}
                {activeTab === "payment" && <AgentOrderPayment />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
